export default __webpack_public_path__ + "static/media/LOGO.3e68ee19.png";